// Google Analytics utility for React
// This replaces the inline script in index.html

/* global dataLayer */

export const initGA = () => {
	// Initialize dataLayer
	window.dataLayer = window.dataLayer || [];

	// Define gtag function
	function gtag() {
		window.dataLayer.push(arguments);
	}

	// Set up gtag
	gtag('js', new Date());
	gtag('config', 'G-5WQYTC1Y0S', {
		cookie_flags: 'secure;samesite=none',
	});

	// Make gtag globally available
	window.gtag = gtag;
};

// Load Google Analytics script dynamically
export const loadGA = () => {
	// Check if already loaded
	if (window.gtag) {
		return;
	}

	// Create and load the script
	const script = document.createElement('script');
	script.async = true;
	script.src = 'https://www.googletagmanager.com/gtag/js?id=G-5WQYTC1Y0S';
	script.onload = () => {
		initGA();
	};

	document.head.appendChild(script);
};
